import React, { useState, useRef } from "react";
import { Chip, Box, IconButton } from "@mui/material";
import { LuFileInput } from "react-icons/lu";
import CloseIcon from "@mui/icons-material/Close";

const FileUrlInput = ({ files, setFiles, text, setText }) => {
  //   const [text, setText] = useState("");
  //   const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileSelect = (e) => {
    const selectedFiles = Array.from(e.target.files).filter(
      (file) => file.type === "application/pdf"
    );
    setFiles((prev) => [...prev, ...selectedFiles]);
  };

  const handleDrop = (e) => {
    e.preventDefault();

    const droppedFiles = Array.from(e.dataTransfer.files).filter(
      (file) => file.type === "application/pdf" || file.type === "text/plain"
    );
    setFiles((prev) => [...prev, ...droppedFiles]);
  };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div
      className=""
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      style={{ position: "relative" }}
    >
      <span className="icon">
        <LuFileInput />
      </span>
      <input
        className="form-control"
        type="text"
        required
        value={text}
        onChange={(e) => setText(e.target.value)}
        // placeholder="Type Website Url or drag and drop any PDF file"
        style={{ paddingLeft: "2rem" }}
      />
      <label className="label">Type Website Url or drag and drop any pdf file</label>

      <input
        type="file"
        accept="application/pdf"
        multiple
        hidden
        ref={fileInputRef}
        onChange={handleFileSelect}
      />

      <Box
        sx={{
          position: "absolute",
          bottom: -50,
          left: 0,
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        {files.map((file, index) => {
          console.log(index);
          return (
            <Chip
              key={index}
              label={file.name}
              onDelete={() => handleRemoveFile(index)}
              deleteIcon={<CloseIcon />}
              color="primary"
              size="small"
            />
          );
        })}
      </Box>
    </div>
  );
};

export default FileUrlInput;
